import { render, staticRenderFns } from "./non-distincted-table.vue?vue&type=template&id=78486a08&"
import script from "./non-distincted-table.vue?vue&type=script&lang=js&"
export * from "./non-distincted-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports